import React from 'react'
import { getPageUrl } from '../../../core/helpers/CoreHelpers';
import { parseContentFields, getFieldDataByKey } from '../../helpers/parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-regular-svg-icons';

const LINK_TYPE = Object.freeze({
  INTERNAL: 1,
  EXTERNAL: 2
});

const DEFAULT_WIDTH_VALUE = 60;

const ClickableTileBlock = (props) => {
  const { contentFields, relatedContents } = props;

  const blockField = parseContentFields(contentFields);
  const blockWidth = getFieldDataByKey(blockField, 'Width.data', DEFAULT_WIDTH_VALUE);

  const cards = relatedContents.reduce((acc, curr) => {
    const cardFields = parseContentFields(curr.contentFields);

    return [...acc, {
      title: getFieldDataByKey(cardFields, 'Title.data'),
      text: getFieldDataByKey(cardFields, 'Text.data'),
      image: getFieldDataByKey(cardFields, 'Image.data'),
      link: getFieldDataByKey(cardFields, 'Link.data'),
    }];
  }, []);

  const handleOnCardClick = (card) => {
    const {
      contentId,
      newTab = false,
      type,
      url
    } = card.link || {};

    const goTo = type === LINK_TYPE.INTERNAL ? getPageUrl(contentId) : url;
    window.open(goTo, newTab ? '_blank' : '_self');
  };

  return (
    <section className={"tile-list w--" + blockWidth + " show--shadow"}>
      <section className="tile-list--inner">
        {
          cards.map((card, i) => (
            <div
              key={i}
              className={`clickable-tile tiles--${cards.length}`}
              style={{
                backgroundImage: card.image && card.image.mediaUrl ? `url(${card.image.mediaUrl})` : `none`,
                width: `${100 / cards.length}%`,
                backgroundPosition: 'center'
              }}
              onClick={() => handleOnCardClick(card)}
            >
              <div className="tile-overlay" />
              <div className="tile-text-container">
                <h4>{card.title}</h4>
                <span>{card.text}</span>
                {card.link && card.link.title && <h4>{card.link.title}</h4>}
              </div>
              {
                card.link && card.link.newTab && <FontAwesomeIcon className="clickable-tile__new-tab-icon" icon={faExternalLinkAlt} />
              }
            </div>
          ))
        }
      </section>
    </section>
  );
};

export default ClickableTileBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/ClickableTileBlock.js